import React from 'react';

import classNames from 'classnames/bind';
import style from './ReadMoreLink.scss';
const ctx = classNames.bind(style);

import { Link } from 'react-router-dom';

const ReadMoreLink = props =>
  props.isInternal ? (
    <Link
      className={ctx('read-more-link')}
      to={props.link}
      style={props.style}
      target={'_self'}
    >
      {props.title}
    </Link>
  ) : (
    <a
      className={ctx('read-more-link')}
      href={props.link}
      style={props.style}
      target={'_blank'}
    >
      {props.title}
    </a>
  );

export default ReadMoreLink;
